export function createPromoteApi() {
  return {};
}

export type PromoteApi = ReturnType<typeof createPromoteApi>;
